import { PopoverInteractionKind } from "@blueprintjs/core";
export const defaultPopoverProps = {
    defaultIsOpen: false,
    fill: true,
    hasBackdrop: false,
    lazy: true,
    rootBoundary: "viewport",
    minimal: true,
    interactionKind: PopoverInteractionKind.CLICK,
};
